module.exports = __webpack_public_path__ + "img/entia-portafolio-energia-carrusel-6.ea36abd7.webp";